



















































































import Vue from "vue";
import EntityCandidate from "@/components/widgets/EntityCandidate.vue";
import EntitySpan from "@/components/widgets/EntitySpan.vue";
import PairwiseTable from "@/components/tables/PairwiseTable.vue";

import * as backend from "@/funcs/backend-requests";
import * as docs from "@/resources/docs/docs";

export default Vue.extend({
  name: "Pairwise",
  components: {
    EntityCandidate,
    EntitySpan,
    PairwiseTable,
  },
  data() {
    return {
      docs: docs,
      // entity search things ----
      entityToSearch: null,
      entityAcQuery: null,
      entityOptions: [],
      isEntitySearchLoading: false,
      // entity search things ----
      dictionary: null,
      dictionaryOptions: [],
      embeddingType: null,
      embeddingTypeOptions: ["bge", "llama3"],
      // results
      pairwiseEntities: [],
      pairwiseResults: [],
    };
  },
  computed: {
    entSelectDisabled(): boolean {
      return !this.dictionary;
    },
    includeBtnDisabled(): boolean {
      const enabled = this.entityToSearch;
      return !enabled;
    },
    submitBtnDisabled(): boolean {
      const enabled = this.pairwiseEntities.length >= 2 && this.embeddingType;
      return !enabled;
    },
    entSelectLabel() {
      const ready = "Search and select an entity";
      const notReady = "Choose a dictionary first";
      if (this.entSelectDisabled) {
        return notReady;
      } else {
        return ready;
      }
    },
  },
  watch: {
    async entityAcQuery(val): Promise<void> {
      if (!val) return;
      if (val.length < 3) return;
      if (this.isEntitySearchLoading) return;
      this.isEntitySearchLoading = true;
      this.entityOptions = await backend.getEntityOptions(val, this.dictionary);
      this.isEntitySearchLoading = false;
    },
  },
  mounted: async function (): Promise<void> {
    this.embeddingType = "bge";
    this.dictionaryOptions = await backend.getDictionaryOptions();
  },
  methods: {
    addEntToList() {
      if (!this.pairwiseEntities.includes(this.entityToSearch)) {
        this.pairwiseEntities.push(this.entityToSearch);
      }
      this.entityToSearch = null;
    },
    async submit(): Promise<void> {
      this.pairwiseResults = await backend.postPairwise(
        this.pairwiseEntities,
        this.embeddingType,
      );
    },
  },
});
